export const sweetpassMembership = {
  // ─── Membership Level ────────────────────────────────────────────────

  'account.sweetpass-membership.title': 'Sweetpass membership',
  'account.sweetpass-membership.membership-level.title':
    'Your membership level',

  // ─── Sweetpass+ ──────────────────────────────────────────────────────

  'account.sweetpass-membership.membership-level.sweetpass-plus.heading':
    'Sweetpass+ member',
  'account.sweetpass-membership.membership-level.sweetpass-plus.body': `Auto-renews on {nextBillingDate} (\${nextBillingPeriodAmount}/mo.)`,

  // ─── Sweetpass+ Cancelled ────────────────────────────────────────────

  'account.sweetpass-membership.membership-level.sweetpass-plus-canceled.heading':
    'Sweetpass member',
  'account.sweetpass-membership.membership-level.sweetpass-plus-canceled.body':
    'Sweetpass+ auto-renewal canceled. Benefits valid through {paidThroughDate}.',
  'account.sweetpass-membership.membership-level.sweetpass-plus-canceled.cta.title':
    'Re-join Sweetpass+',
  'account.sweetpass-membership.membership-level.rejoin-sweetpass-plus.notice.success':
    'Welcome back! Your Sweetpass+ membership is now active.',

  // ─── Sweetpass ───────────────────────────────────────────────────────

  'account.sweetpass-membership.membership-level.sweetpass.heading':
    'Sweetpass member',
  'account.sweetpass-membership.membership-level.sweetpass.body':
    'Member since {joinDate}',
  'account.sweetpass-membership.membership-level.sweetpass.cta.title':
    'Upgrade to Sweetpass+ for $10/month',

  // ─── Sweetpass Downgraded ────────────────────────────────────────────

  'account.sweetpass-membership.membership-level.sweetpass-downgraded.heading':
    'Sweetpass member',
  'account.sweetpass-membership.membership-level.sweetpass-downgraded.body': '',
  'account.sweetpass-membership.membership-level.sweetpass-downgraded.cta.title':
    'Re-join Sweetpass+',

  // ─── Cancellation ────────────────────────────────────────────────────

  'account.sweetpass-membership.cancellation.title': 'Cancellation',
  'account.sweetpass-membership.cancellation.body':
    'By clicking “Cancel Sweetpass+” below, your Sweetpass+ membership will end on 03/30/23. Keep your membership active to keep all-access to your delicious benefits and keep saving.',
  'account.sweetpass-membership.cancellation.cta.title': 'Cancel Sweetpass+',
  'account.sweetpass-membership.cancellation.cta.accessibility-label':
    'Cancel Sweetpass Plus',
  'account.sweetpass-membership.cancellation.notice.success':
    'Your Sweetpass+ membership will end on 03/30/23.',

  // ─── Payment Methods ─────────────────────────────────────────────────

  'account.sweetpass-membership.payment-methods.title': 'Payment methods',
  'account.sweetpass-membership.payment-methods.item.card-ending-in':
    '{cardType} ending in {lastFour}',
  'account.sweetpass-membership.payment-methods.item.accessibility-label.active':
    '{title}; Active',
  'account.sweetpass-membership.payment-methods.item.accessibility-label.inactive':
    '{title}; Inactive',
  'account.sweetpass-membership.payment-methods.item.accessibility-hint':
    'Shows this payment method details',
  'account.sweetpass-membership.payment-methods.item.tag.active': 'Active',
  'account.sweetpass-membership.payment-methods.item.notice.expired':
    'Card expired',
  'account.sweetpass-membership.payment-methods.item.notice.expiring':
    'Card will expire soon',
  'account.sweetpass-membership.payment-methods.add-item.title':
    'Add payment method',
  'account.sweetpass-membership.payment-methods.add-item.accessibility-label':
    'Add payment method',
  'account.sweetpass-membership.payment-methods.add-item.accessibility-hint':
    'Adds a new payment method',
  'account.sweetpass-membership.payment-methods.method-active-message':
    'This is your active membership payment method and cannot be removed.',
  'account.sweetpass-membership.payment-methods.set-active-cta.title':
    'Use for subscription payment',
  'account.sweetpass-membership.payment-methods.remove-cta.title': 'Remove',
  'account.sweetpass-membership.payment-methods.credit-card':
    '• • • •  {lastFour} (Expires {expiresAt})',

  // ─── Billing History ─────────────────────────────────────────────────

  'account.sweetpass-membership.billing-history.header': 'Billing history',
  'account.sweetpass-membership.billing-history.title':
    'Membership billing history',
  'account.sweetpass-membership.billing-history.view-item.title':
    'See full billing history',
  'account.sweetpass-membership.billing-history.view-item.accessibility-label':
    'See full billing history',
  'account.sweetpass-membership.billing-history.view-item.accessibility-hint':
    'Shows the full billing history',
  'account.sweetpass-membership.billing-history.credit-card.description':
    '{cardType} ending in {lastFour}',
  'account.sweetpass-membership.billing-history.no-transactions':
    'There have been no transactions yet.',

  // ─── Contentful Fallbacks ────────────────────────────────────────────

  'membershipData.title': 'Your membership level',
  'membershipData.header': '{membershipLevel} member',
  'membershipData.body.sweetpassPlus': `Auto-renews on {nextBillingDate} (\${nextBillingPeriodAmount}/{nextBillingPeriodRecurrence})`,
  'membershipData.body.sweetpassPlusCancelled':
    'Sweetpass+ auto-renewal canceled. Benefits valid through {paidThroughDate}.',
  'membershipData.body.sweetpass': 'Member since {joinDate}',
  'membershipData.body.sweetpassDowngraded': '',
  'cancellationData.title': 'Cancellation',
  'cancellationData.body':
    'By clicking “Cancel Sweetpass+” below, your Sweetpass+ membership will end on {nextBillingDate}. Keep your membership active to keep all-access to your delicious benefits and keep saving.',
  'cancellationData.cancellationCta': 'Cancel Sweetpass+',
  'cancellationData.genericSuccessMessage':
    'Your Sweetpass+ membership will end on {nextBillingDate}.',
  'paymentMethodsData.title': 'Payment methods',
  'billingHistoryData.title': 'Membership billing history',

  // ─── Sweetpass Membership Errors ─────────────────────────────────────

  'sweetpass-membership.membership-level.rejoin.error': `Your Sweetpass+ membership could not be reactivated.`,
  'sweetpass-membership.cancellation.error': `Your Sweetpass+ membership could not be canceled.`,
  'sweetpass-membership.payment-methods.update.error': `Cannot update active payment method.`,
  'sweetpass-membership.payment-methods.remove.error': `Cannot remove active payment method.`,
};
